import React, { useEffect, useState } from "react";
import { getComponents, getValue } from "../../helpers";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import { onsetClrPicContext, onSetFontStylesVisibility } from "../../../../../../stateManager/store/common/action";
import { AppState } from "../../../../../../stateManager/store";
import { ColorPicker } from "../ColorPicker";
import { FormCreationData } from "../../../../../../stateManager/store/formCreation_v2/types";

const DEFAULT_DATE_RANGE_COLOR_V3: string = "properties.styles.$deviceType.dateRangeColor";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const DateRangeColor = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles, wrapperComputedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component: FormCreationData = components[selectedElementId];
  const { colorPickerContext } = useSelector((state: any) => state.common);
  const dispatch=useDispatch()
  const setFontStylesVisibility = (visibility : boolean) =>{
    dispatch(onSetFontStylesVisibility(visibility))
  }
  const setColorPickerVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: visibility }))
  };

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_DATE_RANGE_COLOR_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.dateRangeColor) {
        setValue(computedStyles.dateRangeColor)
        setOldValue(computedStyles.dateRangeColor)
      } else {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("dateRangeColor") ? wrapperComputedStyles : computedStyles;
        const dateRangeColor = (wrapperStyles && wrapperStyles.dateRangeColor ? wrapperStyles.dateRangeColor : "#158BF8");
        setValue(dateRangeColor)
        setOldValue(dateRangeColor)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  return (
    <ColorPicker
      pickerkey="dateRangeColor"
      label="Date Range Color"
      value={value}
      open={() => {
        setFontStylesVisibility(false)
        dispatch(onsetClrPicContext({
          value: value,
          placeholder: "",
          where: DEFAULT_DATE_RANGE_COLOR_V3,
          visibility: true,
        }));
      }}
      visibility={colorPickerContext?.visibility}
      close={() => setColorPickerVisibility(false)}
    />
  )
};
